import { render, staticRenderFns } from "./Pin.vue?vue&type=template&id=40de0069&scoped=true&"
import script from "./Pin.vue?vue&type=script&lang=js&"
export * from "./Pin.vue?vue&type=script&lang=js&"
import style0 from "./Pin.vue?vue&type=style&index=0&id=40de0069&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de0069",
  null
  
)

export default component.exports